import CmsContent from "component/CmsContent";
import Accordion from "component/design-system/accordion/Accordion";
import { TextArea } from "component/design-system/shared-styles/StyledForm";
import { chunk } from "util/helper/chunk";
interface Props {
  faqs: Array<Faq>
  faqColCount?: number;
}

interface Faq {
  question: string;
  answer?: string;
  article?: string;
}

function FaqAccordion({ faqs, faqColCount = 1 }: Props) {
  if (!faqs) {
    return null;
  }
  const subs = chunk(faqs, Math.ceil(faqs.length / faqColCount));
  return (
    <div className="m-b-20 m-t-20">
      {subs.map((row: any) => (
        <div
          key={row.length + (row.length ? row[0] : "NoLength")}
          className={`col-sm-${12 / subs.length} p-lr-0-xs`}
        >
          {
            row.map((eachFaq) => (
              <Accordion
                key={eachFaq.question}
                title={eachFaq.question}
                content={(
                  <TextArea style={{ margin: 0 }}>
                    <CmsContent content={eachFaq.answer || eachFaq.article} />
                  </TextArea>
                )}
              />
            ))
          }

        </div>
      ))}

    </div>
  );
}

export default FaqAccordion;
